var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var classify = require("./lib/helpers/classify");

async function fetch_ap_data() {
  const response = await fetch(
    "https://apps.npr.org/2024-election-results/data/house.json"
  );
  return response.json();
}

const apMonths = [
  "Jan.",
  "Feb.",
  "March",
  "April",
  "May",
  "June",
  "July",
  "Aug.",
  "Sept.",
  "Oct.",
  "Nov.",
  "Dec.",
];
const timezones = [
  { re: /\(eastern/i, zone: "ET" },
  { re: /\(central/i, zone: "CT" },
  { re: /\(mountain/i, zone: "MT" },
  { re: /\(pacific/i, zone: "PT" },
];
const formatComma = (s) => s.toLocaleString().replace(/\.0+$/, "");
const formatAPDate = (date) =>
  `${apMonths[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
const formatTime = function (date) {
  var h = date.getHours();
  var m = date.getMinutes().toString().padStart(2, "0");
  var suffix = h >= 12 ? "p.m." : "a.m.";
  var offset = date.getTimezoneOffset() / 60;
  var zone = "";
  if (offset >= 4 && offset < 9) {
    var ts = date.toTimeString();
    var match = timezones.filter((tz) => ts.match(tz.re)).pop();
    if (match) zone = " " + match.zone;
  }
  if (h > 12) {
    h -= 12;
  } else if (h == 0) {
    h = 12;
  }
  return `${h}:${m} ${suffix}${zone}`;
};

const compareMargins = (a, b) => {
  const aMargin = a.candidates[0].votes - a.candidates[1].votes;
  const bMargin = b.candidates[0].votes - b.candidates[1].votes;
  return aMargin - bMargin;
};

var onWindowLoaded = function () {
  document.querySelector("#fallback").remove();
  const demContainer = document.querySelector("#dem-container");
  const gopContainer = document.querySelector("#gop-container");
  const demRace = document.querySelector("#dem-race");
  const demColumn = document.querySelector("#dem-column");

  const gopRace = document.querySelector("#gop-race");
  const gopColumn = document.querySelector("#gop-column");
  const allCalled = document.querySelector("#all-called");

  const updated = Math.max(...window.data.map((race) => race.updated));
  const timestamp = `Last updated ${formatAPDate(
    new Date(updated)
  )} at ${formatTime(new Date(updated))}`;
  const demLeads = window.data
    .filter((race) => race.candidates[0].party === "Dem")
    .sort(compareMargins);
  const gopLeads = window.data
    .filter((race) => race.candidates[0].party === "GOP")
    .sort(compareMargins);
  const demCount = demLeads.length;
  const gopCount = gopLeads.length;

  const max = Math.max(
    ...window.data.map(
      (race) => race.candidates[0].votes - race.candidates[1].votes
    )
  );

  const scale = (margin) => (margin / max) * 50;
  const template = (race) => {
    const leader = race.candidates[0];
    const voteMargin = leader.votes - race.candidates[1].votes;
    const percentagePointMargin = (
      (leader.percent - race.candidates[1].percent) *
      100
    ).toFixed(1);
    let footnote = "";
    if (leader.party === race.candidates[1].party) {
      const party = leader.party === "Dem" ? "Democrats" : "Republicans";
      footnote += ". This race is between two " + party + ".";
    }
    if (window.text["footnote" + race.state + race.seatNumber]) {
      footnote += ". " + window.text["footnote" + race.state + race.seatNumber];
    }
    if (race.raceCallStatus === "Awaiting Ranked Choice Results") {
      footnote +=
        ". This race will be decided via <a href='https://www.npr.org/2023/12/13/1214199019/ranked-choice-voting-explainer'>ranked choice voting</a>.";
    }

    return `
      <div class="race-container">
        <p>
          <a href="https://apps.npr.org/2024-election-results/${classify(
            race.stateName
          )}.html?section=H">
            <strong>${race.stateName} ${race.seat}</strong>
          </a>
        </p>
        <p><strong>${leader.last}</strong> leads</p>
        <p>
          <span class="margin-box ${leader.party.toLowerCase()}" style="width: ${scale(
      voteMargin
    )}%"></span>
          +${formatComma(voteMargin)} votes (${percentagePointMargin} points)
        </p>
        <p class="eevp">${(race.eevp * 100).toFixed(
          1
        )}% of votes in${footnote}</p>

      </div>
    `;
  };

  document.querySelector("#timestamp").innerHTML = timestamp;
  document.querySelector("#dem-count").innerHTML = demCount;
  document.querySelector("#gop-count").innerHTML = gopCount;
  demRace.innerHTML = demCount > 1 ? "races" : "race";
  demRace.innerHTML = demCount > 1 ? "races" : "race";

  gopRace.innerHTML = gopCount > 1 ? "races" : "race";

  demLeads.forEach((race) => {
    demContainer.innerHTML += template(race);
  });
  gopLeads.forEach((race) => {
    gopContainer.innerHTML += template(race);
  });

  gopCount == 0 ? (gopColumn.style.display = "none") : "";
  gopCount == 0 ? (demColumn.style.flexBasis = "100%") : "";

  demCount == 0 ? (demColumn.style.display = "none") : "";
  demCount == 0 ? (gopColumn.style.flexBasis = "100%") : "";

  if (gopCount == 0 && demCount == 0) {
    allCalled.innerHTML = "All House races have been called.";
    document.querySelector("#timestamp").style.display = "none";
  }

  pym.then((child) => {
    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
};

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
fetch_ap_data().then((data) => {
  window.data = data.results.filter((d) => !d.called);
  window.addEventListener("load", onWindowLoaded());
});
